import { FC } from 'react';
import { MTDialog } from '@/components/common/MTDialog';
import { COMMON_STRING } from '@/constants/dictionary';
import { ActionDialogProps } from '@/components/ActionsDialog/types';
import { CourtCanvas } from '@/components/CourtCanvas/CourtCanvas';

export const CourtDialog: FC<ActionDialogProps> = ({ action, onClose }) => {
  return (
    <MTDialog
      open={true}
      onClose={onClose}
      title={COMMON_STRING.COURT_POSITION}
    >
      <CourtCanvas
        courtX={action?.metadata.courtPosition.x}
        courtY={action?.metadata.courtPosition.y}
      />
    </MTDialog>
  );
};
